export type FDI_Notation =
  | 18
  | 17
  | 16
  | 15
  | 14
  | 13
  | 12
  | 11
  | 21
  | 22
  | 23
  | 24
  | 25
  | 26
  | 27
  | 28
  | 38
  | 37
  | 36
  | 35
  | 34
  | 33
  | 32
  | 31
  | 41
  | 42
  | 43
  | 44
  | 45
  | 46
  | 47
  | 48;

export interface toothID {
  id: FDI_Notation;
  missing: boolean;
}

export type teethIDs = Array<toothID>;

// Plain FDI sequences per jaw (exported for simpler consumers)
export const upperFDI: Array<FDI_Notation> = [18, 17, 16, 15, 14, 13, 12, 11, 21, 22, 23, 24, 25, 26, 27, 28];
export const lowerFDI: Array<FDI_Notation> = [38, 37, 36, 35, 34, 33, 32, 31, 41, 42, 43, 44, 45, 46, 47, 48];

// Backward‑compatible structured lists (kept for existing imports)
export const upperTeethIds: teethIDs = upperFDI.map((id) => ({ id, missing: false }));
export const lowerTeethIds: teethIDs = lowerFDI.map((id) => ({ id, missing: false }));
